
import DocumentSketch from "../../../assets/filled/DocumentSketch.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DocumentSketchIcon({ className, dataTestid = "DocumentSketchIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <DocumentSketch data-testid={dataTestid} className={classes} {...rest} />
  );
}
